<div class="home-wrapper">
  <div class="stars-bg"></div>
  <div class="stars-fg"></div>

  <app-navbar class="sticky-navbar" [notificationCount]="notificationCount" (locationModal)="showLocationModal = $event"
    (genderModal)="showGenderModal = $event" (settingsModal)="showSettingsModal = $event"
    (notificationsToggled)="onNotificationsToggled($event)" (searchResults)="handleSearchResults($event)"
    (searchTermChange)="updateSearchTerm($event)">
  </app-navbar>

  <!-- 🔍 Search Results Mode -->
  @if (searchActive) {
    <div class="search-results container mt-3">
      <div class="row">
        <!-- ✅ If users found -->
        @if (searchResults.length > 0) {
          @for (user of searchResults; track user) {
            <div class="col-md-6 col-lg-4 mb-3">
              <div class="card card-glass p-3 text-white">
                <h5>{{ user.originalName }}</h5>
                <p>{{ user.username }}</p>
                <div class="d-flex gap-2">
                  <button class="btn btn-sm btn-outline-light" (click)="likeUser(user)">💗</button>
                  <button class="btn btn-sm btn-outline-light" (click)="dislikeUser(user)">💔</button>
                  <button class="btn btn-sm btn-neon" (click)="goTochat(user)">💬</button>
                </div>
              </div>
            </div>
          }
        } @else {
          <div class="col-12">
            <div class="card card-glass p-4 text-white text-center">
              <h4 class="mb-2">🧐 No Users Found</h4>
              <p>Try searching a different username or check back later!</p>
            </div>
          </div>
        }
        <!-- ❌ No results -->
      </div>
    </div>
  }

  <!-- Location Modal -->
  @if (showLocationModal) {
    <div class="modal-backdrop">
      <div class="modal-content card-glass p-4 position-relative">
        <button class="btn-close btn-close-white position-absolute top-0 end-0 m-3" (click)="showLocationModal = false"
        aria-label="Close"></button>
        <h5 class="text-white mb-3">Set Location Range</h5>
        <input placeholder="km" type="range" min="1" max="1000" [(ngModel)]="kmRange" class="form-range" />
        <p class="text-white">Selected: {{ kmRange }} km</p>
        <input type="number" [(ngModel)]="kmInput" placeholder="Enter km manually" class="form-control mb-3" />
        <button class="btn btn-neon w-100" (click)="applyLocationFilter()">OK</button>
      </div>
    </div>
  }

  <!-- Gender Modal -->
  @if (showGenderModal) {
    <div class="modal-backdrop">
      <div class="modal-content card-glass p-4 position-relative">
        <button class="btn-close btn-close-white position-absolute top-0 end-0 m-3" (click)="showGenderModal = false"
        aria-label="Close"></button>
        <h5 class="text-white mb-3">Select Gender</h5>
        <select title="select" class="form-select mb-3" [(ngModel)]="genderFilter">
          <option value="" disabled selected>Select...</option>
          <option value="male">Male 🚹</option>
          <option value="female">Female 🚺</option>
          <option value="other">Other ⚧️</option>
        </select>
        <button class="btn btn-neon w-100" (click)="applyGenderFilter()">OK</button>
      </div>
    </div>
  }

  <!-- notification modal -->
  @if (showNotifications) {
    <div class="modal-backdrop">
      <div class="modal-content card-glass p-4 position-relative">
        <button class="btn-close btn-close-white position-absolute top-0 end-0 m-3" (click)="closenotifications()"
        aria-label="Close"></button>
        <h5 class="text-white mb-3">👥 Users</h5>
        <!-- SCROLLABLE USER LIST -->
        <div class="user-list-scroll">
          @for (user of notificationUsers; track user) {
            <div class="user-card mb-3 p-3 d-flex align-items-center justify-content-between card-glass"
              >
              <div>
                <h6 class="mb-1">{{ user.originalName }}</h6>
                <small class="text-muted">{{ user.username }}</small>
              </div>
              <div class="d-flex gap-2">
                <button class="btn btn-sm btn-outline-light" (click)="likeUser(user)">💗</button>
                <button class="btn btn-sm btn-outline-light" (click)="dislikeUser(user)">💔</button>
                <button class="btn btn-sm btn-neon" (click)="goTochat(user)">💬</button>
              </div>
            </div>
          }
        </div>
        <!-- END SCROLLABLE USER LIST -->
        <ng-template #noNotifs>
          <p class="text-white">No users to show</p>
        </ng-template>
      </div>
    </div>
  }


  <!-- settingsModal -->

  @if (showSettingsModal) {
    <div class="modal-backdrop">
      <div class="modal-content card-glass p-4 position-relative">
        <button class="btn-close btn-close-white position-absolute top-0 end-0 m-3" (click)="showSettingsModal = false"
        aria-label="Close"></button>
        <h5 class="text-white mb-3">Settings</h5>
        <button class="btn btn-outline-light mind w-100 mb-3" (click)="goToPreferences()">
          💗 View Liked / Disliked Users
        </button>
        <button class="btn btn-danger w-100" (click)="deleteAccount()">🗑 Delete Account Permanently</button>
      </div>
    </div>
  }


  <!--  Delete Account Confirmation Modal -->
  @if (showDeleteConfirm) {
    <div class="modal-backdrop">
      <div class="delmodal modal-content card-glass p-4 text-white position-relative">
        <button class="btn-close btn-close-white position-absolute top-0 end-0 m-3" (click)="cancelDelete()"
        aria-label="Close"></button>
        <h4 class="mb-3">⚠️ Confirm Deletion</h4>
        <p class="mb-4">Are you sure you want to <strong>permanently delete</strong> your account?</p>
        <p class="text-danger fw-bold">This action cannot be undone.</p>
        <div class="d-flex justify-content-end gap-2 mt-4">
          <button class="btn btn-outline-light" (click)="cancelDelete()">Cancel</button>
          <button class="btn btn-danger" (click)="confirmDeleteAccount()">Yes, Delete</button>
        </div>
      </div>
    </div>
  }


  @if (noUsers) {
    <div class="no-users-wrapper">
      <div class="no-users-content">
        <div class="no-users-icon">📡</div>
        <h3>No Users Nearby</h3>
        <p>We couldn't find anyone around your location right now.</p>
        <p>Try expanding your search distance or check back later 👀</p>
      </div>
    </div>
  }
  <!-- User List -->
  <div class="user-list container mt-5">
    <div class="row">
      @for (user of nearbyUsers; track user) {
        <div class="col-md-6 col-lg-4 mb-4">
          <div class="card card-glass p-3 text-white d-flex flex-column align-items-start">
            <h5>{{ user.originalName }}</h5>
            <p class="mb-2">{{ user.username }}</p>
            <div class="d-flex gap-2 mt-auto">
              <button class="btn btn-sm btn-outline-light" (click)="likeUser(user)">💗 Like</button>
              <button class="btn btn-sm btn-outline-light" (click)="dislikeUser(user)">💔 Dislike</button>
              <button class="btn btn-sm btn-neon" (click)="goTochat(user)">💬 Chat</button>
            </div>
          </div>
        </div>
      }
    </div>
    @if (noMoreUsers) {
      <div class="no-users-wrapper">
        <div class="no-users-content">
          <div class="no-users-icon">📡</div>
          <h3>No more Users...</h3>
          <p>We couldn't find anymore users around your location right now.</p>
          <p>Try expanding your search distance or check back later 👀</p>
        </div>
      </div>
    }
  </div>
  <div class="lastdiv"></div>
</div>

<app-spinner [show]="spinner" [message]="spinMessage" />